import AddButton from "components/Button/AddButton";
import React, { useContext, useEffect, useRef, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { DropdownMonthList, DropdownStatusList, EmptyString, FilterPeriodeOptions, FormTypeAdd, InsertDateFormat, PageSize, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import EditIcon from "assets/icon/EditIcon";
import Dropdown from "components/Input/Dropdown";
import { addSpaceEvery4, GetStatus, money, removeNonNumeric } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import XIcon from "assets/icon/XIcon";
import FilterIcon from "assets/icon/FilterIcon";
import { useCallApi } from "api/apiHooks";
import { useModal } from "utils/context/ModalContext";
import Pagination from "components/Input/PaginationButton";
import { FilterCard, GridDeleteButton, GridEditButton, MainBodyCard, PagesTitle } from "components/Cards";
import Select from 'react-select'
import DataTable from "components/DataTable";
import DatePicker from "components/Input/DatePicker";
import { CommonService } from "services/CommonService/CommonService";
import moment from "moment";
import { ExpenseService } from "services/ExpenseService/ExpenseService";
import { useVariable } from "utils/context/VariableContext";

export default function Expense(){
    const { locationId } = useVariable()
    let navigate = useNavigate()
    const firstLoad = useRef(true)
    const debounceRef = useRef(null)

    const { fetchCommon } = CommonService()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchDeleteCustomerCard } = useCallApi()
    const { fetchExpenseList, fetchDeleteExpense } = ExpenseService()

    const [dateFrom, setDateFrom] = useState(new Date())
    const [dateTo, setDateTo] = useState(new Date())
    const [remark, setRemark] = useState('')
    const [categoryOptions, setCategoryOptions] = useState([])
    const [categoryId, setCategoryId] = useState('')
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [expenseList, setExpenseList] = useState([])
    const [periodeFilterType, setPeriodeFilterType] = useState('2')
    const [periodeFilterMonth, setPeriodeFilterMonth] = useState(moment(new Date()).format('M'))
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [isFilterOpen, setIsFilterOpen] = useState(false)

    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center"
        },
        {
            key: "expenseDate",
            header: "Tanggal",
            render: (row) => moment(row.expenseDate).format("DD MMM YYYY"),
        },
        {
            key: "categoryName",
            header: "Category",
            render: (row) => row.categoryName.toUpperCase(),
        },
        {
            key: "remark",
            header: "Remark",
            render: (row) => row.remark.toUpperCase(),
        },
        {
            key: "amount",
            header: "Nominal",
            render: (row) => 'Rp ' + money(row.amount),
        },
        {
            key: "locationName",
            header: "Lokasi",
            render: (row) => row.locationName.toUpperCase(),
        },
        {
            key: "status",
            header: "Status",
            render: (row) => GetStatus(row.status),
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <div className="flex gap-2">
                    <GridEditButton isActive={row.status} onClick={() => editBtnClick(row.expenseId)} size="w-3" />
                    <GridDeleteButton isActive={row.status} status={row.status} onClick={() => deleteBtnClick(row.expenseId, row.status)} size="w-3" />
                </div>
            ),
        },
    ]
    
    const isFilterOpenClick = () => {
        setIsFilterOpen(!isFilterOpen)
    }

    const handlePageChange = async (newIndex) => {
        try {
            showLoading()

            let dateStart = ''
            let dateEnd = ''

            if (periodeFilterType === '1') {
                dateStart = moment(new Date()).format(InsertDateFormat)
                dateEnd = moment(new Date()).format(InsertDateFormat)
            } else if (periodeFilterType === '2') {
                dateStart = moment().month(periodeFilterMonth - 1).startOf('month').format(InsertDateFormat)
                dateEnd = moment().month(periodeFilterMonth - 1).endOf('month').format(InsertDateFormat)
            } else if (periodeFilterType === '3') {
                dateStart = moment().startOf('year').format(InsertDateFormat)
                dateEnd = moment().endOf('year').format(InsertDateFormat)
            } else if (periodeFilterType === '4') {
                dateStart = moment(dateFrom).format(InsertDateFormat)
                dateEnd = moment(dateTo).format(InsertDateFormat)
            }

            const res = await fetchExpenseList(
                dateStart,
                dateEnd,
                categoryId === '' ? 0 : categoryId,
                remark,
                status,
                parseInt(locationId),  
                PageSize, 
                parseInt(newIndex)
            )

            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setExpenseList(res)
            setTotalPages(total)
            setPageIndex(newIndex)
        } finally {
            hideLoading()
        }
    }

    const editBtnClick = (id) => {
        navigate("/expense/form?expenseId=" + id + "&formType=Edit")
    }
    const deleteBtnClick = async (id, status) => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            const res = await fetchDeleteExpense(id, status)
            if (!res) return

            showSuccess()
            handlePageChange(pageIndex)
        }
    }

    const getCategoryOptions = async () => {
        const res = await fetchCommon('expense_category_options')
        if (!res) return

        const data = res.data
        const options = []
        data.map((x) => options.push({label: x.commonText, value: x.commonValue}))
        setCategoryOptions(options)

        return res
    }

    useEffect(() => {
        const onLoad = async () => {
            if (firstLoad.current) {
                showLoading()

                // Get Bank List
                const res = await getCategoryOptions()
                if (!res) return
                
                handlePageChange(0)

                firstLoad.current = false
            }
            else {
                if (debounceRef.current) {
                    clearTimeout(debounceRef.current)
                }
        
                debounceRef.current = setTimeout(() => {
                    handlePageChange(0)
                }, 500)
            }
        }

        onLoad()
    },[dateFrom, dateTo, remark, categoryId, status, periodeFilterType, periodeFilterMonth, locationId])

    return(
        <MainBodyCard>
            <PagesTitle title='Pengeluaran' />

            <div className="xl:hidden mt-2 flex justify-end">
                <button className="bg-black rounded-md flex gap-2 px-4 py-2" onClick={isFilterOpenClick}>
                    {isFilterOpen ? <XIcon className="fill-white w-6" /> : <FilterIcon className="fill-white w-6" />}
                    <span className="text-white">Filter</span>
                </button>
            </div>

            <div className={`flex flex-col xl:flex-row gap-5 justify-between mt-2 ${isFilterOpen ? 'flex' : 'hidden xl:flex'}`}>
                <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-4 w-full">
                    <FilterCard title='Periode Filter' width='w-full sm:w-52'>
                        <Select className='w-full' value={FilterPeriodeOptions.find(opt => opt.value === periodeFilterType)} 
                            options={FilterPeriodeOptions} onChange={(e) => { setPeriodeFilterType(e.value) }} placeholder={"All"} />
                    </FilterCard>

                    {periodeFilterType === '2' && (
                        <FilterCard title='Bulan' width='w-full sm:w-52'>
                            <Select className='w-full' value={DropdownMonthList.find(opt => opt.value === periodeFilterMonth)} 
                                options={DropdownMonthList} onChange={(e) => { setPeriodeFilterMonth(e.value) }} placeholder={"All"} />
                        </FilterCard>
                    )}
                    
                    {periodeFilterType === '4' && (
                        <div className="flex gap-4">
                            <FilterCard title='Dari Tanggal' width='w-full sm:w-52'>
                                <DatePicker className='w-full' value={dateFrom} onChange={setDateFrom} />
                            </FilterCard>

                            <FilterCard title='Sampai Tanggal' width='w-full sm:w-52'>
                                <DatePicker className='w-full' value={dateTo} onChange={setDateTo} />
                            </FilterCard>
                        </div>
                    )}

                    <FilterCard title='Category' width='w-full sm:w-64'>
                        <Select className='w-full' value={categoryOptions.find(opt => opt.value === categoryId)} 
                            options={categoryOptions} onChange={(e) => { setCategoryId(e.value) }} placeholder={"All"} />
                    </FilterCard>

                    <FilterCard title='Remark' width='w-full sm:w-64'>
                        <input className="input" value={remark} onChange={(e) => setRemark(e.target.value)} />
                    </FilterCard>

                    <FilterCard title='Status' width='w-full sm:w-32'>
                        <Dropdown className='w-full' value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder={"All"} />
                    </FilterCard>
                </div>
            </div>

            <div className="mt-3 flex justify-end">
                <AddButton onClick={() => navigate('/expense/form?expenseId=&formType=' + FormTypeAdd)} title='Tambah Pengeluaran' />
            </div>
            
            <div className="hidden xl:block mt-4">
                <DataTable
                    columns={columns}
                    data={expenseList?.data?.listData ?? []}
                    footer={
                        <tr className="h-10 font-semibold">
                            <td colSpan={4} className="text-right pr-2">Total</td>
                            <td>{"Rp " + money(String(Math.floor(expenseList?.data?.totalAmount)))}</td>
                        </tr>
                    }
                />
            </div>

            <div className="block xl:hidden mt-4">
                <div className="flex flex-col gap-3">
                    {expenseList?.data?.listData?.map((data, i) => {
                        // return(
                        //     <div className="bg-white p-3 border shadow flex justify-between">
                        //         <div className="flex flex-col">
                        //             <label>{data.customerName.toUpperCase()}</label>
                        //             <label>{data.cardNumber}</label>
                        //             <label>{data.bankName + " - " + data.cardVendorName}</label>
                        //         </div>
                        //         <div className="flex flex-col justify-between">
                        //             <button className="button flex gap-2" onClick={() => editBtnClick(data.customerCardId)}>
                        //                 <EditIcon className="w-4 fill-white" />
                        //             </button>
                        //             <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.customerCardId, data.status)}>
                        //                 <TrashIcon className="w-4 fill-white" />
                        //             </button>
                        //             <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.customerCardId, data.status)}>
                        //                 <RevisionIcon className="w-4 fill-white" />
                        //             </button>
                        //         </div>
                        //     </div>
                        // )
                    })}
                </div>
            </div>

            <Pagination pageIndex={pageIndex} totalPages={totalPages} onPageChange={handlePageChange} />
        </MainBodyCard>
    )
}